import forOwn from 'mout/object/forOwn'

/**
 * Creates array of all objects with specified prop value matching given value
 * @param {object} obj object consisting of objects to be filtered 
 * @param {string} prop the key to filter for 
 * @param {string} value the value for the prop that must match
 * @param {string} role optionally specifies a role that also must match. 
 * @returns {array} array of matching objects
 */
export default function getObjectsMatchPropVal(obj, prop, value, role) {
  let output = []
  forOwn(obj, (val, key, o) => {
    if (val[prop] === value) {
      if (!role || val.role === role) {
        output.push(val)
      }
    }
  })
  return output
}


// WEBPACK FOOTER //
// ./src/helpers/getObjectsMatchPropVal.js